import { ICategory, IKeyword, IkeywordsByType, TFormattedKeywordsByRetailer, TKeyword, TRetailerRow } from 'types';

export const generateCategoryKeywords = (category: ICategory, checkedOnly = false): number[] => {
    const categoryKeywords: number[] = [];
    if (category.keywords) {
        if (!checkedOnly || (checkedOnly && category.checked)) {
            category.keywords.forEach((keyword) => {
                if (!categoryKeywords.includes(keyword)) categoryKeywords.push(keyword);
            });
        }
    } else if (category.subRows) {
        category.subRows.forEach((cat) => {
            const subcategoryKeywords = generateCategoryKeywords(cat, checkedOnly);
            if (subcategoryKeywords) {
                subcategoryKeywords.forEach((keyword) => {
                    if (!categoryKeywords.includes(keyword)) categoryKeywords.push(keyword);
                });
            }
        });
    }
    return categoryKeywords;
};

export const getRetailerKeywords = (retailer: TFormattedKeywordsByRetailer | TRetailerRow): number[] => {
    if (retailer.level === 'retailer') {
        return retailer.keywords.map((keyword) => Number(keyword.id));
    } else if (retailer.subRows) {
        const retailerKeywords: number[] = [];
        retailer.subRows.forEach((subRetailer) => {
            const subRetailerKeywords = getRetailerKeywords(subRetailer);
            subRetailerKeywords.forEach((keywordId) => {
                if (!retailerKeywords.includes(keywordId)) {
                    retailerKeywords.push(keywordId);
                }
            });
        });
        return retailerKeywords;
    }
    return [];
};

export const getRetailerKeywordsObjs = (
    retailer: TFormattedKeywordsByRetailer | TRetailerRow,
): { id: number; name: string }[] => {
    if (retailer.level === 'retailer') {
        return retailer.keywords;
    } else if (retailer.subRows) {
        // use loadash here if slow
        // time both methods
        const retailerKeywords: { id: number; name: string }[] = [];
        retailer.subRows.forEach((subRetailer) => {
            const subRetailerKeywords = getRetailerKeywordsObjs(subRetailer);
            subRetailerKeywords.forEach((keyword) => {
                if (!retailerKeywords.some((k) => k.id === keyword.id)) {
                    retailerKeywords.push(keyword);
                }
            });
        });
        return retailerKeywords;
    }
    return [];
};

export const generateCategoriesKeywords = (categories: ICategory[], checkedOnly = false): number[] => {
    const categoryKeywords: number[] = [];
    categories.forEach((category) => {
        const categoryKeywordsIds = generateCategoryKeywords(category, checkedOnly);
        categoryKeywordsIds.forEach((keywordId) => {
            if (!categoryKeywords.includes(keywordId)) categoryKeywords.push(keywordId);
        });
    });
    return categoryKeywords;
};

export const getSelectedRetailers = (retailerList: TFormattedKeywordsByRetailer[]): TRetailerRow[] => {
    const retailers: TRetailerRow[] = [];

    retailerList.forEach((type) => {
        if (type.subRows && type.subRows.length) {
            if (type.checked) {
                retailers.push(...type.subRows);
            } else {
                type.subRows.forEach((retailer) => {
                    if (retailer.checked) {
                        retailers.push(retailer);
                    }
                });
            }
        }
    });

    return retailers;
};

export const getSelectedSegments = (category: ICategory[]): ICategory[] => {
    const segments: ICategory[] = [];
    category.forEach((cat) => {
        if (cat.level === 'segment' && cat.checked) {
            segments.push(cat);
        } else if (cat.subRows) {
            const subSegments = getSelectedSegments(cat.subRows);
            if (subSegments.length) segments.push(...subSegments);
        }
    });
    return segments;
};

export const getCheckedKeywordsIds = (keywords: IkeywordsByType[]): number[] => {
    const checkedKeywords: number[] = [];
    keywords.forEach((keyword) => {
        keyword.keywords.forEach((k) => {
            if (k.checked) checkedKeywords.push(Number(k.id));
        });
    });
    return checkedKeywords;
};

export const getKeywordNames = (
    keywords: { keyword_id: number; name: string }[] | undefined,
    keywordIds: number[],
): string[] => {
    const keywordNames: string[] = [];
    keywordIds.forEach((keywordId) => {
        const keyword = keywords?.find((k) => k.keyword_id === keywordId);
        if (keyword) keywordNames.push(keyword.name);
    });
    return keywordNames;
};
